import React from 'react';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
var LazyEditRichTextParagraph = lazyForPaint(function () {
  return import( /* webpackChunkName: "async-proforma-edit-rich-text-paragraph" */'./main').then(function (_ref) {
    var EditRichTextParagraph = _ref.EditRichTextParagraph;
    return EditRichTextParagraph;
  });
}, {
  ssr: false
});
export var AsyncEditRichTextParagraph = function AsyncEditRichTextParagraph(props) {
  return /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazyEditRichTextParagraph, props));
};